import { MultiString } from "../../i18n/MultiString";

export class RJParserMessages
{
  static missingLeftArgument:MultiString = 
  {
    en:"Missing left argument"
  }

  static missingRightArgument:MultiString = 
  {
    en:"Missing right argument"
  }

  static missingCloseSymbolOfGroup:MultiString = 
  {
    en:"Missing close symbol of group"
  }

  static expressionCouldNotBeResolved:MultiString = 
  {
    en:"Expression could not be resolved"
  }

  static unexpectedSeperatorPosition:MultiString = 
  {
    en:"Unexpected seperator position"
  }

  static expectedSeperator:MultiString = 
  {
    en:"Expected seperator"
  }

  static missingParameter:MultiString = 
  {
    en:"Missing parameter"
  }

  static missingParameters:MultiString = 
  {
    en:"Missing parameters"
  }

  static wrongNumberOfParameters:MultiString = 
  {
    en:"Wrong number of parameters"
  }

  static parametersNotFitting:MultiString = 
  {
    en:"Parameters not fitting"
  }
}
